/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ValidationPredicate } from '../model/validation-predicate.model';
import { ValidationRules } from '../model/validation-rules.model';

export class ValidationProvider {

  private static readonly predicateMap = new Map<string, ValidationPredicate>();
  private static readonly objectRulesMap = new Map<string, { [key: string]: ValidationRules }>();

  static registerPredicate(key: string, predicate: ValidationPredicate) {
    ValidationProvider.predicateMap.set(key, predicate);
  }

  static resolvePredicate(key: string): ValidationPredicate {
    return ValidationProvider.predicateMap.get(key);
  }

  static registerObjectRules(key: string, rules: { [key: string]: ValidationRules }) {
    ValidationProvider.objectRulesMap.set(key, rules);
  }

  static resolveObjectRules(key: string): { [key: string]: ValidationRules } {
    return ValidationProvider.objectRulesMap.get(key);
  }

}
